import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getFieldAccessPins, pinsMatch } from "../utils/fieldAccessConfig";
import HQPage from "./HQPage";

export default function HQLoginPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [debug, setDebug] = useState("");
  const [unlocked, setUnlocked] = useState(false);
  const [loginBusy, setLoginBusy] = useState(false);

  useEffect(() => {
    const session = sessionStorage.getItem("fieldAccessHQ");
    if (session === "true") setUnlocked(true);
    setLoading(false);
  }, []);

  async function handleLogin(e) {
    if (e) e.preventDefault();
    if (loginBusy) return;

    const enteredPin = pin.trim();
    if (!enteredPin) return;

    setLoginBusy(true);
    setError("");
    setDebug("Checking PIN...");

    try {
      const config = await getFieldAccessPins();

      setDebug(`Config loaded. HQ PIN exists: ${config?.hqPin ? "YES" : "NO"}`);

      if (!pinsMatch(enteredPin, config?.hqPin)) {
        setError("Invalid PIN");
        setLoginBusy(false);
        return;
      }

      sessionStorage.setItem("fieldAccessHQ", "true");
      sessionStorage.setItem("fieldAccessStatusBoard", "true");

      if (sessionStorage.getItem("fieldAccessSource") !== "command") {
        sessionStorage.setItem("fieldAccessSource", "hq");
      }

      setUnlocked(true);
    } catch (err) {
      console.error("HQ login error:", err);
      setError("Unable to load PIN configuration");
      setDebug(err?.message || String(err));
      setLoginBusy(false);
    }
  }

  function handleLock() {
    sessionStorage.removeItem("fieldAccessHQ");

    if (sessionStorage.getItem("fieldAccessSource") === "hq") {
      sessionStorage.removeItem("fieldAccessStatusBoard");
      sessionStorage.removeItem("fieldAccessSource");
    }

    setUnlocked(false);
    setPin("");
    setError("");
    setDebug("");
    setLoginBusy(false);
  }

  if (loading) return <div style={{ padding: 20 }}>Loading...</div>;

  if (!unlocked) {
    return (
      <div style={styles.center}>
        <div style={styles.card}>
          <button onClick={() => navigate("/field-access")} style={styles.backBtn}>
            ← Back
          </button>

          <h2>HQ Access</h2>

          <form onSubmit={handleLogin}>
            <input
              type="password"
              placeholder="Enter PIN"
              value={pin}
              onChange={(e) => setPin(e.target.value)}
              style={styles.input}
              autoComplete="off"
            />

            <button type="submit" style={styles.button} disabled={loginBusy}>
              {loginBusy ? "Opening..." : "Enter"}
            </button>
          </form>

          {!!error && <div style={styles.error}>{error}</div>}
          {!!debug && <div style={styles.debug}>{debug}</div>}
        </div>
      </div>
    );
  }

  return <HQPage />;
}

const styles = {
  center: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f8fafc",
  },
  card: {
    background: "#fff",
    padding: 24,
    borderRadius: 12,
    width: 320,
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
  },
  input: {
    width: "100%",
    padding: 12,
    marginBottom: 12,
    boxSizing: "border-box",
  },
  button: {
    width: "100%",
    padding: 12,
    background: "#0f766e",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    fontWeight: 700,
    cursor: "pointer",
  },
  backBtn: {
    background: "transparent",
    border: "1px solid #cbd5e1",
    padding: "6px 10px",
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: 700,
    marginBottom: 10,
  },
  error: {
    color: "red",
    marginTop: 10,
  },
  debug: {
    marginTop: 10,
    fontSize: 12,
    color: "#475569",
    background: "#f1f5f9",
    padding: 8,
    borderRadius: 6,
  },
};